import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import EventsMuseumItemForm from "./EventsMuseumItemForm";
import EventsMuseumItemBrowser from "./EventsMuseumItemBrowser";

const EventsMuseumPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="event"
            modeApiName2="events"
            ItemBrowserComponent={EventsMuseumItemBrowser}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            browserFilterExtraParams={{kultural_goals: "museum"}}
            pageOptions={{kultural_goal: "museum"}}
            ItemFormComponent={EventsMuseumItemForm}
        />
    );
};

export default EventsMuseumPage;